(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papacou-home-hero"] && !Shopify.designMode) return;
  try {
    
  function setupPapacouHomeHero(root = document) {
    root.querySelectorAll('.pc-home [data-pc-motion]').forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const videos = Array.from(button.closest('.pc-home').querySelectorAll('video'));
      if (!videos.length) return;
      button.hidden = false;
      const setPaused = (paused) => {
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
        videos.forEach((video) => {
          if (paused) video.pause();
          else video.play().catch(() => {});
        });
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) setPaused(true);
      button.addEventListener('click', () => setPaused(button.getAttribute('aria-pressed') !== 'true'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupPapacouHomeHero());
  else setupPapacouHomeHero();
  document.addEventListener('shopify:section:load', (event) => setupPapacouHomeHero(event.target));

  } catch(e) { console.error(e); }
})();
})();
